<template lang="html">
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Future Availability</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <span class="info">
                Here you can set how far in the future your diary is made available to Players.
            </span>

            <form class="form3" v-if="form">
                <div class="formGroup" style="margin-bottom: 10px">
                    <div class="select">
                        <select
                            v-model="form.diary_availability_months"
                            :class="{ selected: form.diary_availability_months }"
                        >
                            <option value="1">1 month</option>
                            <option value="2">2 months</option>
                            <option value="3">3 months</option>
                            <option value="4">4 months</option>
                            <option value="5">5 months</option>
                            <option value="6">6 months</option>
                            <option value="7">7 months</option>
                            <option value="8">8 months</option>
                            <option value="9">9 months</option>
                            <option value="10">10 months</option>
                            <option value="11">11 months</option>
                            <option value="12">12 months</option>
                        </select>
                        <img class="arrow" src="@/assets/arrow-right-green.svg" />
                    </div>
                </div>

                <div class="form-group">
                    <button class="button" @click.prevent="updateAvailability">Save</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
export default {
    name: "manage-diary",
    components: { FadeImage, XIcon },
    data() {
        return {
            form: false,
        };
    },
    created() {
        this.form = new Form(this.$store.state.user);
    },
    methods: {
        updateAvailability() {
            this.$confirm(
                "This will update your availability. Are you sure you want to continue?",
                () => {
                    this.form.post("/availability-diary-months-availability").then(() => {
                        this.$notify("Availability updated");
                        this.$store.state.user.diary_availability_months =
                            this.form.diary_availability_months;
                    });
                },
                "Yes, continue",
                "No, cancel",
            );
        },
    },
};
</script>

<style lang="scss">
.dayPicker {
    margin-bottom: 20px;
}
</style>
